import React, { useState } from "react";

/**
 * LS-640 — saisie manuelle du taux VR (fraction 0-1) quand la grille
 * constructeur n'a pas de correspondance pour la durée/km d'un palier
 * intermédiaire (erreur API `taux_vr_introuvable`). Calquée sur le pattern
 * de ConfirmModal.
 */
const TauxVrManuelModal = ({
  isOpen,
  message,
  isLoading = false,
  onSubmit,
  onCancel,
}) => {
  const [value, setValue] = useState("");

  if (!isOpen) return null;

  const numericValue = Number(value);
  const isValid = value !== "" && numericValue >= 0 && numericValue <= 1;

  const handleSubmit = () => {
    if (!isValid) return;
    onSubmit(numericValue);
    setValue("");
  };

  const handleCancel = () => {
    setValue("");
    onCancel();
  };

  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      onClick={handleCancel}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="fas fa-exclamation-triangle text-warning mr-2"></i>
              Taux VR manuel requis
            </h5>
            <button type="button" className="close" onClick={handleCancel}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <p>
              {message ||
                "La grille constructeur ne contient aucun taux de valeur résiduelle exploitable pour cette période."}
            </p>
            <p>
              Saisissez un taux manuel (fraction entre 0 et 1, ex : 0.40 pour
              40 %) pour poursuivre le calcul.
            </p>
            <input
              type="number"
              className="form-control"
              min="0"
              max="1"
              step="0.01"
              placeholder="Ex : 0.40"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              disabled={isLoading}
              autoFocus
            />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              onClick={handleCancel}
              disabled={isLoading}
            >
              Annuler
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={isLoading || !isValid}
            >
              <i className="fas fa-check mr-1"></i>
              Valider
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TauxVrManuelModal;
